<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<div class="container">
  <div [ngClass]="login.contraste ? 'card-panel mt-5 fundo-contraste' : 'card-panel mt-5 fundo-normal'">
    <div class="row">
      <div class="col-md-8">
        <img src="assets/img/print.png" alt="pesquisa" width="42" height="42">
        <span
          [ngClass]="this.login.contraste ? 'titulo-txt-contraste fonte-acessibilidade ml-2' : 'titulo-txt-normal fonte-acessibilidade ml-2'">EXECUÇÃO
          ORÇAMENTÁRIA - LRF</span>
      </div>
      <div class="col-md-4">
        <a type="button" routerLink="/transparencia/contas-publica"
          class="btn btn-sm btn-outline-secondary float-right  ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="30" width="30">
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 pt-2">
        <label
          [ngClass]="this.login.contraste ? 'text-white font-weight-bold fonte-acessibilidade' : 'text-black-50 font-weight-bold fonte-acessibilidade'">
          {{login.orgao.codigo}} {{login.orgao.nome}}
        </label>
      </div>
      <div class="col-md-4">

      </div>
    </div>
    <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-4' : 'linha-normal mt-1 mb-4'" />
    <div class="row">
      <div class="form-group col-md-8">
        <label for="mes">Selecione o anexo</label>
        <select [(ngModel)]="anexoSelect" name="selectAnexo" style="font-weight: bold; color: #1565c0"
          class="custom-select custom-select-sm">
          <option [selected]="item.id === anexoSelect" [value]="item.id" *ngFor="let item of listaAnexos">
            {{item.nome}}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-3">
        <label for="mes">Selecione o mês</label>
        <select [(ngModel)]="mes" id="mes" name="selectOrgao" style="font-weight: bold;"
          class="form-control custom-select">
          <option [value]="1">JANEIRO</option>
          <option [value]="2">FEVEREIRO</option>
          <option [value]="3">MARÇO</option>
          <option [value]="4">ABRIL</option>
          <option [value]="5">MAIO</option>
          <option [value]="6">JUNHO</option>
          <option [value]="7">JULHO</option>
          <option [value]="8">AGOSTO</option>
          <option [value]="9">SETEMBRO</option>
          <option [value]="10">OUTUBRO</option>
          <option [value]="11">NOVEMBRO</option>
          <option [value]="12">DEZEMBRO</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-3">
        <label for="ano">Exercício</label>
        <select [compareWith]="compareFn" [(ngModel)]="exercicioSelect" id="ano" class="form-control custom-select">
          <option *ngFor="let item of listaExercicios" [ngValue]="item">
            {{item.ano}}
          </option>
        </select>
      </div>
    </div>
    <div class="row mt-3">
      <div class="form-group col-md-3">
        <a (click)="imprimir()" class="btn btn-sm btn-outline-secondary">
          <img src="assets/img/global/file_pdf.png" alt="cvs" title="Gerar pdf" height="30" width="30">
          Gerar PDF
        </a>
      </div>
    </div>

  </div>
</div>